import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import Acao from "model/administracao/cadastro/Acao";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Local from "model/patrimonio/Local";
import Deposito from "model/suprimentos/Deposito";
import NotaFiscalEntrada from "model/suprimentos/NotaFiscalEntrada";
import Transacao from "model/suprimentos/Transacao";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class NotaFiscalEntradaService implements BaseServiceCadastros<NotaFiscalEntrada> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        console.log("logo");
        return new Promise<Page>((resolve, reject): void => {
            console.log("Entrou no Return")
            let url = `/notaFiscalEntrada/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };
            
            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
                console.log(url);
        });
    }

    consultar(id: string | number) {
        return new Promise<NotaFiscalEntrada>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/consultar/${id}`)
                .then(response => {
                    const notaFiscalEntrada: NotaFiscalEntrada = response.data;
                    notaFiscalEntrada.itens.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });
                    resolve(notaFiscalEntrada)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(data: FormData) {
        return new Promise<NotaFiscalEntrada>((resolve, reject): void => {
            let url = `/notaFiscalEntrada/incluir`;
            apiFile
                .post(url, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(data: FormData) {
        return new Promise<NotaFiscalEntrada>((resolve, reject): void => {
            apiFile
                .put(`/notaFiscalEntrada/editar`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: string | number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/notaFiscalEntrada/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    fechar(notaFiscalEntrada: NotaFiscalEntrada) {
        return new Promise<NotaFiscalEntrada>((resolve, reject): void => {
            api
                .put(`/notaFiscalEntrada/fechar`, JSON.stringify(notaFiscalEntrada))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    reabrir(notaFiscalEntrada: NotaFiscalEntrada) {
        return new Promise<NotaFiscalEntrada>((resolve, reject): void => {
            api
                .put(`/notaFiscalEntrada/reabrir`, JSON.stringify(notaFiscalEntrada))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutosComprados() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/produtos/comprados`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutosPatrimoniaveis() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/produtos/patrimoniaveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getFornecedores() {
        return new Promise<Array<Pessoa>>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/fornecedores`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getUsuarios() {
        return new Promise<Array<Pessoa>>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getDepositos() {
        return new Promise<Array<Deposito>>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/depositos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getLocais() {
        return new Promise<Array<Local>>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/locais`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTransacoes() {
        return new Promise<Array<Transacao>>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/transacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getStatusLista(){
        return [{
            value: 'DIGITADA',
            label: 'Digitada'
        },
        {
            value: 'FECHADA',
            label: 'Fechada'
        }]
    }

    getStatus(status: string): string{
        let statusObj = this.getStatusLista().find((item) => item.value === status)
        if(statusObj){
            return statusObj.label
        }
        return "";
    }

    getStatusNotaFiscalEntradaFilter() {
        return [
            { label: 'Digitada', value: 'D' },
            { label: 'Fechada', value: 'F' },

        ]

    }

    getTransacaoPadrao() {
        return new Promise<Transacao>((resolve, reject): void => {
            api
                .get(`/notaFiscalEntrada/transacaoPadrao`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    
    }


}

export default NotaFiscalEntradaService;
